module.exports = __webpack_public_path__ + "img/ícone-seta-esquerda-cinza.98a83a74.svg";